import { useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'

import userActions from 'actions/user'
import { getIsAuthenticated } from 'selectors/auth'
import { getUserId } from 'selectors/user'

export const useGlobalBootstrap = () => {
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(getIsAuthenticated)
  const userId = useSelector(getUserId)

  useEffect(() => {
    if (isAuthenticated && !userId) {
      dispatch(userActions.userLoadData())
    }
  }, [isAuthenticated, userId, dispatch])
}
